import { Bubble } from 'components/NewsletterModal/components/Bubble';
import styles from './styles.scss';
import { rm } from 'utils';
import { IconMail } from 'components/Shared/Icon/themes/BGH-RD3/iconMail';

interface TagProps {
  isDiscountVariant: boolean;
  onClick: () => void;
}

interface StickyTagProps extends TagProps {
  isMobile: boolean;
}

export const CSS_STICKY_OFFSET_PROP_KEY = '--tagBottomOffset';

const MobileTag = ({ isDiscountVariant, onClick }: TagProps) => {
  return (
    <div className={styles.mobileBtn} onClick={onClick}>
      {isDiscountVariant ? (
        <>
          <p className={styles.amountContainer}>
            <span className={styles.discountAmount}>{rm('Newsletter_Push_Discount_Amount')}</span>%
          </p>
          <p className={styles.discount}>{rm('Newsletter_Push_Discount_Header')}</p>
        </>
      ) : (
        <IconMail />
      )}
    </div>
  );
};

const Tag = ({ isDiscountVariant, onClick }: TagProps) => {
  return (
    <div className={styles.stickyTag} onClick={onClick}>
      <Bubble isDiscount={isDiscountVariant} isStickyMode={true} />
    </div>
  );
};

export const StickyTag = ({ isDiscountVariant, isMobile, onClick }: StickyTagProps) => {
  return isMobile ? (
    <MobileTag isDiscountVariant={isDiscountVariant} onClick={onClick} />
  ) : (
    <Tag isDiscountVariant={isDiscountVariant} onClick={onClick} />
  );
};
